import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PageHeading } from '@/app/PageHeading';
import { Tabs, TabsList, TabsTrigger } from '@/components/arc/tabs/tabs';
import { useHref } from '@/module/basePath';

const TABS = [
  { value: 'publishers', label: 'Publishers' },
  { value: 'creatives', label: 'Creatives' },
  { value: 'campaigns', label: 'Campaigns' },
] as const;
type TabValue = (typeof TABS)[number]['value'];

/**
 * Overlay section shell: one heading, Arc tabs that navigate between the publisher, creative and campaign
 * routes, then the child route. Child pages render sections only (the h1 lives here).
 */
export function OverlayLayout() {
  const href = useHref();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active: TabValue = TABS.find((t) => pathname.includes(`/overlay/${t.value}`))?.value ?? 'publishers';

  return (
    <main className="page">
      <PageHeading
        title="Overlay"
        description="Publisher SDK, creatives and moment-triggered overlay campaigns"
        below={
          <Tabs
            value={active}
            onValueChange={(next) => {
              if (next !== active) navigate(href(`/overlay/${next}`));
            }}
          >
            <TabsList aria-label="Overlay sections">
              {TABS.map((t) => (
                <TabsTrigger key={t.value} value={t.value}>
                  {t.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        }
      />
      <Outlet />
    </main>
  );
}
